'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Usage :
 *
 *  $dialogBox.confirm({
                title: "Le titre",
                text: "La question ?"
                html : "La question en html ?"
            }).then(function () {
             // si confirmé
            });
 */
ngModule.factory("$dialogBox", function ($q, $translate, $modal) {
  return {
    alert: function alert(options) {
      var vars = _.extend({}, options);
      return $modal.open({
        template: require("./alertDialog.html"),
        vars: vars,
        options: {
          escape: false
        }
      });
    },
    confirm: function confirm(options) {
      var vars = _.extend({
        confirmLabel: "common.dialog.confirm",
        cancelLabel: "common.dialog.cancel"
      }, options);
      return $modal.open({
        template: require("./confirmDialog.html"),
        vars: vars,
        options: {
          escape: true
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/dialogs/$dialogBox.js
// module id = 2929
// module chunks = 13